<template>
  <div class="flex h-13">
    <div class="flex pl-6 bg-slate-100 sticky left-88 z-10">
      <div
        class="flex items-center border-b border-l border-r border-slate-400 bg-pure-white"
        :class="{ 'rounded-bl': isLast }"
      >
        <div class="w-20 px-4 flex flex-shrink-0 gap-2">
          <BlTextBody2 :text="item.id" class="truncate text-slate-1000" />
        </div>
        <div
          class="w-60 px-4 flex flex-shrink-0 gap-2"
          :title="item.client.name"
        >
          <BlTextBody2
            :text="item.client.name"
            class="truncate text-slate-1000"
          />
        </div>
      </div>
    </div>
    <div
      class="w-30 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
    >
      <BlChip :chip="item.status" />
    </div>
    <div
      class="w-40 pl-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
    >
      <BlTextBody2 :text="displayDate(item.date)" />
    </div>
    <div
      class="w-40 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
    >
      <BlTextBody2
        :text="`${item.start_time_string} - ${item.end_time_string}`"
      />
    </div>
    <div
      v-if="enableBranch"
      class="w-50 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
    >
      <BlTextBody2 v-if="!item.room || !item.room.branch" text="-" />
      <div
        v-else
        class="h-7 max-w-44 px-2 flex items-center justify-center rounded"
        :style="{
          backgroundColor: item.room.branch.background_color || 'unset'
        }"
        :title="item.room.branch.name"
      >
        <BlTextBody2
          class="truncate"
          :text="item.room.branch.name || '-'"
          :style="{
            color: item.room.branch.color || 'unset'
          }"
        />
      </div>
    </div>
    <div
      v-if="enableAppointment"
      class="w-50 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
    >
      <BlTextBody2 v-if="!item.room" text="-" class="truncate" />
      <BlTextBody2
        :text="item.room.name"
        :title="item.room.name"
        class="truncate"
      />
    </div>
    <div
      class="w-80 px-4 flex-shrink-0 bg-pure-white flex items-center border-b border-slate-400"
    >
      <BlTextBody2
        v-if="item.supervisors.length"
        :text="item.supervisors.map(i => i.name).join(', ')"
        :title="item.supervisors.map(i => i.name).join(', ')"
        class="truncate"
      />
      <BlTextBody2 v-else text="-" />
    </div>
    <div class="flex pr-6 bg-slate-100 sticky right-0" :style="{ zIndex: 1 }">
      <div
        class="w-50 px-4 flex-shrink-0 bg-pure-white flex-grow flex items-center justify-end border-b border-r border-slate-400"
        :class="{ 'rounded-br': isLast }"
      >
        <router-link
          v-if="item.status === 'scheduled'"
          class="cursor-pointer"
          title="View session draft"
          :to="`/session/${item.session.slug}/edit`"
        >
          <BlInputButton type="outlined" dense label="View session draft" />
        </router-link>
        <router-link
          v-if="item.status === 'in_progress'"
          class="cursor-pointer"
          title="Resume session"
          :to="`/session/${item.session.slug}`"
        >
          <BlInputButton type="outlined" dense label="Resume session" />
        </router-link>
        <router-link
          v-if="item.status === 'completed' || item.status === 'cancelled'"
          class="cursor-pointer"
          title="View session"
          :to="`/session/${item.session.slug}`"
        >
          <BlInputButton type="outlined" dense label="View session" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import BlTextBody2 from "../../BlTextBody2.vue";
import BlChip from "../../BlChip.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "MySessionItem",
  components: {
    BlTextBody2,
    BlChip,
    BlInputButton
  },
  props: {
    item: { type: Object, required: true },
    isLast: { required: false }
  },
  data() {
    return {
      menuOpened: false
    };
  },
  watch: {
    menuOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableAppointment() {
      return this.currentCenter.enable_appointment;
    },
    enableBranch() {
      return this.currentCenter.enable_branch;
    }
  },
  methods: {
    ...mapActions([]),
    displayDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    closeHandler() {
      window.removeEventListener("click", this.closeHandler);
      this.menuOpened = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mySessions/table/Item.vue